/**
 * Checkbox Component
 *
 * Reusable checkbox with label
 * - Error state
 * - Disabled state
 * - Indeterminate state
 */

import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./Checkbox.scss";

export const Checkbox = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  error = false,
  indeterminate = false,
  className = "",
  ...props
}) => {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const checkboxClasses = [
    "checkbox",
    error && "checkbox--error",
    disabled && "checkbox--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <label className={checkboxClasses}>
      <input
        ref={checkboxRef}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="checkbox__input"
        {...props}
      />
      <span className="checkbox__box">
        <svg
          className="checkbox__check"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 4L6 11L3 8"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {label && <span className="checkbox__label">{label}</span>}
    </label>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  indeterminate: PropTypes.bool,
  className: PropTypes.string,
};

export default Checkbox;
